/** @format */

import React, { Suspense, lazy, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from 'src/ui/layout';
import { updateBodyClass } from 'src/helpers';
import { BODY_CLASSES } from 'src/constants/constants.js';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';
import withRouter from 'src/utils/withRouter';
import intl from 'react-intl-universal';

const CONSENT_MANAGEMENT_RESTORE_STATE_KEY = 'consentManagement:restoreDashboardState';

const ConsentManagementLandingContainer = lazy(() =>
  import('src/ui/features/ConsentManagement/containers/ConsentManagementLandingContainer')
);
const ConsentManagementDetailContainer = lazy(() =>
  import('src/ui/features/ConsentManagement/containers/DetailViewContainer/ConsentManagementDetailContainer')
);

const ConsentManagementLandingContainerWithRouter = withRouter(ConsentManagementLandingContainer);
const ConsentManagementDetailContainerWithRouter = withRouter(ConsentManagementDetailContainer);

const ConsentManagementRoot = () => {
  useEffect(() => {
    updateBodyClass(BODY_CLASSES.ADMIN);
    return () => {
      try {
        sessionStorage.removeItem(CONSENT_MANAGEMENT_RESTORE_STATE_KEY);
      } catch (e) {
        return null;
      }
      updateBodyClass(BODY_CLASSES.ADMIN);
      return null;
    };
  }, []);

  return (
    <Layout headerName={intl.get('globalMenu.consentManagement')}>
      <Suspense fallback={<ServiceSpinner open={true} />}>
        <Routes>
          <Route
            path={'detail/:consentManagementId'}
            element={<ConsentManagementDetailContainerWithRouter />}
          />
          <Route
            path={'*'}
            element={<ConsentManagementLandingContainerWithRouter />}
          />
        </Routes>
      </Suspense>
    </Layout>
  );
};

export default ConsentManagementRoot;
